<template>
  <div id="app">
    <!-- Header -->
    <app-header></app-header>

    <transition name="fade-down" mode="out-in" appear>
     <div>
       <!-- Router -->
       <div class="router-view-wrapper">
         <transition name="fade-down" mode="out-in" appear v-if="appMounted">
           <router-view></router-view>
         </transition>

         <div v-if="!appMounted">
           <router-view></router-view>
         </div>
       </div>

       <!-- Footer -->
       <div class="footer-wrapper">
         <app-footer></app-footer>
       </div>
     </div>
    </transition>

    <consent-widget/>
  </div>
</template>

<script>
import AppHeader from '@/components/layout/header/AppHeader';
import AppFooter from '@/components/layout/footer/AppFooter';
import {mixinMetaTitleHandler} from '@/mixins/meta-title-handler';
import ConsentWidget from '@/components/widgets/consent/Consent';

export default {
  name: 'App',

  data: function() {
    return {
        appMounted: false,
    }
  },

  mixins: [mixinMetaTitleHandler],

  components: {
    AppHeader, AppFooter, ConsentWidget,
  },

  mounted: function () {
    this.$nextTick(function () {
      this.appMounted = true;
    });
  },
}
</script>

<style lang="scss">
  .footer-wrapper {
    width: 100%;
    float: left;
  }

  @keyframes fadeInDown {
    from {
      opacity: 0.05;
      transform: translate3d(0, -60px, 0);
    }
    to {
      opacity: 1;
      transform: none;
    }
  }

  @keyframes fadeOutUp {
    from {
      opacity: 1;
      transform: none;
    }
    to {
      opacity: 0.05;
      transform: translate3d(0, -60px, 0);
    }
  }

  .fade-down-enter-active {
    animation-name: fadeInDown;
    animation-duration: 0.5s;
  }

  .fade-down-leave-active {
    animation-name: fadeOutUp;
    animation-duration: 0.3s;
  }

  .router-view-wrapper {
    width: 100%;
    height: 100%;
    min-height: calc(100vh - 100px);
    float: left;
  }
</style>
